import React, {useState} from 'react';
import {Button, TextField} from '@mui/material';
import './forgotModal.scss';
import closeIcon from '../images/close.svg';
import {authService} from '../../services/auth.service';
import useSnackBar from '../../hooks/useSnackBar';

function ForgotModal({close, openRegister, openAuth} : any) {
    const [email, setEmail] = useState('');
    const [emailErrorText, setEmailErrorText] = useState('');
    const {setSnackBar} = useSnackBar();

    const submitHandler = () => {
        if(!email) setEmailErrorText('Введите email');
        else if(!email.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )?.length) setEmailErrorText('Введите верный email');
        else {
            authService.forgotPassword(email).then(() => {
                setSnackBar({title: 'Запрос успешно отправлен, ожидайте email  инструкциями.', isActive:true, status:'success'});
                openAuth();
            }).catch((e) => {
                setSnackBar({title:e.response.data.detail, isActive:true, status:'error'});
            });
        }
    }

    return (
        <div className="modal-content">
            <button onClick={() => close()} className="close-btn">
                <img src={closeIcon} alt="close-modal"/>
            </button>
            <div className="auth-modal-content">
                <h3>Забыли пароль?</h3>
                <div className="to-register-text">
                    У вас еще нет учетной записи?
                    <span className="to-register-link" onClick={openRegister}>Зарегистрироваться</span>
                </div>
                <TextField label={"Электронная почта"}
                           sx={{marginTop:'32px'}}
                           error={emailErrorText?.length > 0}
                           helperText={emailErrorText}
                           onChange={(e) => setEmail(e.target.value)}
                />
                <Button sx={{marginTop: '40px'}} className="blue-btn" variant="contained" onClick={submitHandler}>Сбросить пароль</Button>
                <Button sx={{marginTop: '12px', width: '100%'}} variant="outlined" onClick={openAuth}>Вернуться назад</Button>
            </div>
        </div>);
}

export default ForgotModal;
